export enum SplitFeatures {
  // permanent Splits
  MAINTENANCE_MODE = 'MAINTENANCE_MODE',
  SYMON_EMBED = 'SYMON_EMBED',
  SYMON_EMBED_CONF = 'SYMON_EMBED_CONF',
  CONTRIBUTOR_VIEW_MAPS_PINS = 'CONTRIBUTOR_VIEW_MAPS_PINS',

  // feature Splits
  TQM = 'TQM',
  FILE_ERROR_TAB_ENABLED = 'FILE_ERROR_TAB_ENABLED',
  COPILOT = 'COPILOT',
  COPY_PC_PROGRESS = 'COPY_PC_PROGRESS',
  CUSTOM_HIERARCHY_ATTRIBUTES_V2 = 'CUSTOM_HIERARCHY_ATTRIBUTES_V2',
  IMPORT_HIERARCHIES_SYMON = 'IMPORT_HIERARCHIES_SYMON',
  COLUMN_SUBSET_MAPPING = 'COLUMN_SUBSET_MAPPING',
  IS_SHARED_COMPUTED_COLUMN_LIB_ENABLED = 'IS_SHARED_COMPUTED_COLUMN_LIB_ENABLED',
  TERRITORY_OPTIMIZATION = 'TERRITORY_OPTIMIZATION',
  BULK_DELETION_TERRITORIES = 'BULK_DELETION_TERRITORIES',
  QUOTA_TARGET_SETTING = 'QUOTA_TARGET_SETTING',
  HIDECALCCOLUMNTOTALS = 'HIDECALCCOLUMNTOTALS',
  CALC_COLUMN_UPDATE = 'CALC_COLUMN_UPDATE',
  MAP_UNDO = 'MAP_UNDO',
  PERIODICITY_CALC_COLUMN = 'PERIODICITY_CALC_COLUMN',
  NEW_TERRITORY_QUOTA_FILE_MAPPING_FIELDS = 'NEW_TERRITORY_QUOTA_FILE_MAPPING_FIELDS',
  HIDE_CALC_PERCENT_TOTALS = 'HIDE_CALC_PERCENT_TOTALS',
  MAP_SINGLE_CUSTOM_HIERARCHY = 'MAP_SINGLE_CUSTOM_HIERARCHY',
  COMMENTING_MANAGE_WORKFLOW = 'COMMENTING_MANAGE_WORKFLOW',
  COLUMN_HIGHLIGHTING = 'COLUMN_HIGHLIGHTING',
  MAP_CENTERING = 'MAP_CENTERING',
  MATCHING_ENGINE = 'MATCHING_ENGINE',
  AUDIT_TRAIL_EXPORT_ASYNC = 'AUDIT_TRAIL_EXPORT_ASYNC',
  SINGLE_ACCOUNT_TERRITORY = 'SINGLE_ACCOUNT_TERRITORY',
  AMWQ_ACCOUNT_QUOTA_IN_GRID = 'AMWQ_ACCOUNT_QUOTA_IN_GRID',
  AMWQ_TWO_HIERARCHIES = 'AMWQ_TWO_HIERARCHIES',
  AMWQ_TWO_HIERARCHIES_SORT_FILTER = 'AMWQ_TWO_HIERARCHIES_SORT_FILTER',
  REMOVE_BOOTSTRAP = 'REMOVE_BOOTSTRAP',
  AMWQ_ACCOUNT_QUOTA_IN_TERRITORY_QUOTA_GRID = 'AMWQ_ACCOUNT_QUOTA_IN_TERRITORY_QUOTA_GRID',
  AMWQ_MAX_SELLERS = 'AMWQ_MAX_SELLERS',
  SELLER_ASSIGNMENT_FILE_UPLOAD_MANAGE = 'SELLER_ASSIGNMENT_FILE_UPLOAD_MANAGE',
  ALLOW_CUSTOM_SYMON_DOMAIN = 'ALLOW_CUSTOM_SYMON_DOMAIN',
  MANAGE_QBT_SORT_FILTER = 'MANAGE_QBT_SORT_FILTER',
  ACCOUNT_FIRST_MAP = 'ACCOUNT_FIRST_MAP',
  SELLER_ASSIGNMENT_TWO_DECIMAL_PLACES = 'SELLER_ASSIGNMENT_TWO_DECIMAL_PLACES',
  BASE_RULE_FILTERS = 'BASE_RULE_FILTERS',
  MATCH_ON_SELECTION_TOGGLE = 'MATCH_ON_SELECTION_TOGGLE',
  DUPLICATE_ACCOUNT_RULE_GRID_OVERRIDE = 'DUPLICATE_ACCOUNT_RULE_GRID_OVERRIDE',
  DUPLICATION_FID_IN_RULE_EDITOR_EXCEPTION_FILE = 'DUPLICATION_FID_IN_RULE_EDITOR_EXCEPTION_FILE',
  MAP_STYLE_ENHANCEMENTS = 'MAP_STYLE_ENHANCEMENTS',
  QUOTA_GRID_TOTALS_SLOWNESS = 'QUOTA_GRID_TOTALS_SLOWNESS',
  DISALLOW_MEASURE_NAME_WITH_UNDERSCORE = 'DISALLOW_MEASURE_NAME_WITH_UNDERSCORE',
  COPY_PC_ECS = 'COPY_PC_ECS',
  MAP_SEGMENTATION = 'MAP_SEGMENTATION',
  ACCOUNT_MAP_WARNING = 'ACCOUNT_MAP_WARNING',
  READY_FOR_REVIEW_TAG_IN_SCENARIO_PLANNING = 'READY_FOR_REVIEW_TAG_IN_SCENARIO_PLANNING',
  ACCOUNT_QUOTA_GRID_FILTER = 'ACCOUNT_QUOTA_GRID_FILTER',
  RESOLVE_DUPLICATE_TERRITORY = 'RESOLVE_DUPLICATE_TERRITORY',
  CREATION_OF_TERRITORIES_IN_YEAR = 'CREATION_OF_TERRITORIES_IN_YEAR',
  TERRITORY_GROUP_EFFECTIVE_DATES = 'TERRITORY_GROUP_EFFECTIVE_DATES',
  PAGE_SIZES_CONFIG = 'PAGE_SIZES_CONFIG',
  OPTIMIZE_UI_BUTTON_UPDATE = 'OPTIMIZE_UI_BUTTON_UPDATE',
  ADDED_CONFIGURATIONS_FOR_USER_PERMISSIONS = 'ADDED_CONFIGURATIONS_FOR_USER_PERMISSIONS',
  OVERLAY_ASSISTANT_IN_SCENARIO_COMPARISION_MODE = 'OVERLAY_ASSISTANT_IN_SCENARIO_COMPARISION_MODE',
  STATUS_MENU = 'STATUS_MENU',
  BC_TG_DESCRIPTIONS = 'BC_TG_DESCRIPTIONS',
  MAINTENANCE_BANNERS = 'MAINTENANCE_BANNERS',
  GENERATE_FILTER_FROM_TERRITORY = 'GENERATE_FILTER_FROM_TERRITORY'
}
